// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './../proxy/apiMap';
import 'vant/lib/index.css'

import Vue from 'vue'
import Vant from 'vant'
import App from './App'
import router from './router'
import 'amfe-flexible';
Vue.use(Vant);
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js